window.addEventListener('scroll', onScroll);

let lastScrollTop = 0;

function onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > lastScrollTop) {
    document.body.classList.remove('scrolled-up');
    document.body.classList.add('scrolled-down');
  } else {
    document.body.classList.add('scrolled-up');
    document.body.classList.remove('scrolled-down');
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

  if (window.scrollY === 0) {
    document.body.classList.remove('scrolled');
  } else {
    document.body.classList.add('scrolled');
  }

  if (window.scrollY >= 100) {
    document.body.classList.add('scrolled-100');
  } else {
    document.body.classList.remove('scrolled-100');
  }

  if (window.scrollY >= 160) {
    document.body.classList.add('scrolled-160');
    setTimeout(() => document.body.classList.add('scrolled-160-after'), 300);
  } else {
    document.body.classList.remove('scrolled-160');
    setTimeout(() => document.body.classList.remove('scrolled-160-after'), 300);
  }
}